import { render, staticRenderFns } from "./ServiceSlots.vue?vue&type=template&id=250aed12&scoped=true"
import script from "./ServiceSlots.vue?vue&type=script&lang=js"
export * from "./ServiceSlots.vue?vue&type=script&lang=js"
import style0 from "./ServiceSlots.vue?vue&type=style&index=0&id=250aed12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250aed12",
  null
  
)

export default component.exports